import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Typography, Paper, TextField, Grid, Button, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import AppContext from '../AppContext';
import Footer from '../components/Footer';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    },

    flexCenterer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.primary.main
    },

    loginContainer: {
        width: '335px',
        padding: theme.spacing.unit * 2,
    },

    loginTitle: {
        textTransform: 'uppercase',
        fontSize: '16px',
        lineHeight: '25px'
    },

    loginButtonContainer: {
        textAlign: 'right'
    }
});

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: props.getUser() != null || false,
            email: '',
            password: ''
        };

        this.loginCallback = this.loginCallback.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.loginButtonHandler = this.loginButtonHandler.bind(this);
    }

    loginCallback(result) {
        window.location.reload();
    }

    inputChangeHandler(event) {
        const target = event.target;
        const name = target.name;
        const value = target.value;

        let scopeObj = {};
        scopeObj[name] = value;

        this.setState(scopeObj);
    }

    loginButtonHandler() {
        AppContext.login(this.state.email, this.state.password)
            .then(this.loginCallback)
            .catch((e) => {
                AppContext.toast(this.props.t('Kirjautuminen epäonnistui, yritä uudelleen'));
            });
    }

    render() {
        const { classes } = this.props;

        if (this.state.redirect) {
            return <Redirect to="/" />;
        }

        return (
            <div className={classes.container}>
                <div className={classes.flexCenterer}>
                    <Paper
                        square={true}
                        className={classes.loginContainer}>
                        <Grid container spacing={24}>
                            <Grid item xs={12}>
                                <Typography className={classes.loginTitle} variant="title">{this.props.t('Kirjaudu sisään Lukelokiin')}</Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                    type="email"
                                    label={this.props.t('Käyttäjätunnus')}
                                    name="email"
                                    value={this.state.email}
                                    onChange={this.inputChangeHandler}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                    type="password"
                                    label={this.props.t('Salasana')}
                                    name="password"
                                    value={this.state.password}
                                    onChange={this.inputChangeHandler}
                                />
                            </Grid>

                            <Grid item xs={12} className={classes.loginButtonContainer}>
                                <Button
                                    variant="raised"
                                    color="primary"
                                    onClick={this.loginButtonHandler}
                                >
                                    {this.props.t('Kirjaudu')}
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </div>

                <Footer />
            </div>
        );
    }
}

Login.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withTranslation()(withStyles(styles)(Login));



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Login.js